import { render } from "./replies-item.vue?vue&type=template&id=8380a0ec&scoped=true&ts=true"
import script from "./replies-item.vue?vue&type=script&lang=ts"
export * from "./replies-item.vue?vue&type=script&lang=ts"

import "./replies-item.vue?vue&type=style&index=0&id=8380a0ec&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8380a0ec"]])

export default __exports__